import React, { useEffect, useState } from 'react';
import { Palette, Award, Calendar } from 'lucide-react';
import { concorsoDisegno } from '../data/mock';
import { api } from '../api/client';

export default function ConcorsoDisegno() {
  const [data, setData] = useState({
    visibile: true,
    etichetta: 'Novità 2026',
    titolo: concorsoDisegno.titolo,
    descrizione: concorsoDisegno.descrizione,
    dettagli: concorsoDisegno.dettagli,
    premiazione: concorsoDisegno.premiazione,
    icon_url: '',
  });

  useEffect(() => {
    let alive = true;
    api.getConcorso().then((d) => {
      if (!alive || !d) return;
      setData({
        visibile: d.visibile !== false,
        etichetta: d.etichetta || 'Novità 2026',
        titolo: d.titolo || concorsoDisegno.titolo,
        descrizione: d.descrizione || concorsoDisegno.descrizione,
        dettagli: d.dettagli || concorsoDisegno.dettagli,
        premiazione: d.premiazione || concorsoDisegno.premiazione,
        icon_url: d.icon_url || '',
      });
    }).catch(() => { /* fallback su mock */ });
    return () => { alive = false; };
  }, []);

  if (!data.visibile) return null;

  return (
    <section className="py-16 bg-navy-dark">
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        <div className="glass-card overflow-hidden">
          <div className="grid lg:grid-cols-2">
            <div className="p-8 lg:p-10">
              <div className="inline-flex items-center gap-2 bg-pink-brand/20 border border-pink-brand rounded-full px-4 py-1.5 mb-4">
                <Palette size={14} className="text-pink-brand" />
                <span className="text-pink-brand text-[11px] font-bold uppercase tracking-widest">{data.etichetta}</span>
              </div>
              <h3 className="font-display text-3xl md:text-4xl font-bold text-white uppercase mb-4">{data.titolo}</h3>
              <p className="text-white/80 leading-relaxed mb-5">{data.descrizione}</p>
              <p className="text-white/75 text-sm leading-relaxed mb-6">{data.dettagli}</p>
              <div className="flex flex-wrap items-center gap-4">
                <div className="flex items-center gap-2 text-white font-semibold">
                  <Calendar size={18} className="text-pink-brand" />
                  <span className="text-sm">{data.premiazione}</span>
                </div>
              </div>
            </div>
            <div className="relative min-h-[280px] lg:min-h-full bg-pink-brand/10 flex items-center justify-center p-8">
              {data.icon_url ? (
                <img src={data.icon_url} alt={data.titolo} className="max-w-full max-h-[260px] object-contain animate-float" />
              ) : (
                <div className="relative">
                  <div className="absolute inset-0 bg-pink-brand rounded-full blur-3xl opacity-30"></div>
                  <Award size={180} className="text-pink-brand relative animate-float" strokeWidth={1.2} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
